import { AnyUser } from "@megaron/access-control";
import { diffSyncActions } from "@megaron/diff-sync-contracts";
import { HttpService } from "@megaron/http-service";
import { HandlerMap } from "@megaron/http-service-host";

import { calculateActions } from "./calculate";
import { shippingDiffSyncSchema } from "./diffSync";
import { unitTemplateActions } from "./unitTemplate";

export const shippingHttpService = HttpService({
  ...unitTemplateActions,
  ...calculateActions,
  ...diffSyncActions(shippingDiffSyncSchema),
});

export type ShippingHandlers = HandlerMap<typeof shippingHttpService, AnyUser>;
